const validateFunderReport = function ({ commit, state }) {
  commit("VALIDATE_FUNDER_REPORT");
  return Promise.resolve(state.fundersReportErrors);
};

export default validateFunderReport;
